<!--
 * @Author: Latte
 * @Date: 2021-10-20 11:08:28
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-12 16:33:45
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\QuizManagement\AnswerList.vue
-->
<template>
	<div>
		<el-table :data="tableData" :header-cell-style="{ background: '#F5F7FA' }"
			style="width: 100%; margin-bottom: 20px" border="">
			<el-table-column label="#" prop="problemAnswerId" align="center"></el-table-column>
			<el-table-column label="#ProblemID" prop="problemId" align="center"></el-table-column>
			<el-table-column label="提交用户" prop="nickname" align="center" show-overflow-tooltip>
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
			<el-table-column label="答案内容" prop="content" align="center"></el-table-column>
			<el-table-column label="创建时间" align="center">
				<template slot-scope="scope">
					{{ scope.row.createTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column label="更改时间" align="center">
				<template slot-scope="scope">
					{{ scope.row.modifyTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column label="单位" prop="organization" align="center"></el-table-column>
			<el-table-column label="赞同数" prop="agreeCount" align="center"></el-table-column>
			<el-table-column label="评论数" prop="commentCount" align="center"></el-table-column>
			<el-table-column label="操作" width="400" align="center">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="handleViewReply(scope.row)">查看评论</el-button>
					<el-button type="primary" size="small" @click="handleCheckAnswerFile(scope.row)">查看文件</el-button>
					<el-button :type="scope.row.bestStatus === 0 ? 'primary' : 'warning'" size="small"
						@click="handleSwitchBest(scope.row)">{{
              scope.row.bestStatus === 0 ? "设为最佳答案" : "取消最佳答案"
            }}</el-button>
					<el-button type="primary" size="small" @click="handleSetReward(scope.row)">设置奖励麦粒</el-button>
					<el-button :type="scope.row.isDeleted ? 'warning' : 'danger'" size="small"
						@click="handleRemoveAnswer(scope.row)">{{ scope.row.isDeleted ? "恢复" : "删除" }}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination background layout="prev, pager, next" :total="totalCount" :page-size="pageSize"
			:current-page="currentPage" @current-change="currentChange" />

		<!-- 查看文件对话框 -->
		<el-dialog title="查看答案文件" :visible.sync="fileDialogVisible" width="80%">
			<el-table :data="filesList">
				<el-table-column label="#" align="center" prop="answerFileId"></el-table-column>
				<el-table-column label="文件" align="center" prop="fileUrl" width="300">
					<template slot-scope="scope">

						<audio v-if="scope.row.fileType === 2" :src="`${config.RESOURCES + scope.row.fileUrl}`" controls
							type="audio/m4a"></audio>

            <div v-else style="width: 100px; height: 100px;position: relative; display: flex;justify-content: center;">
							<el-image fit="scale-down"
								:src="getImageUrl(scope.row)" lazy :key="getImageUrl(scope.row)"
								:preview-src-list="[getImageUrl(scope.row)]">
							</el-image>
							<i v-if="scope.row.fileType === 1" class="el-icon-video-play"
								style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: aliceblue;"
								@click.stop="viewVideo(scope.$index, scope.row)"></i>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="文件类型" align="center">
					<template slot-scope="scope">
						{{ scope.row.fileType | formatFileType }}
					</template>
				</el-table-column>
				<el-table-column label="创建时间" align="center">
					<template slot-scope="scope">
						{{ scope.row.createTime | formatDateTime }}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="danger" size="small" @click="handleRemoveFile(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background layout="prev, pager, next" :total="answerFileTotalCount"
				:page-size="answerFilePageSize" :current-page="answerFileCurrentPage"
				@current-change="answerFileCurrentPageChange" />

			<span slot="footer" class="dialog-footer">
				<el-button @click="fileDialogVisible = false" size="small" type="primary">返 回</el-button>
			</span>
		</el-dialog>

		<!-- 查看视频 -->
		<el-dialog title="查看视频" :visible.sync="viewVideoDialog" width="60%" :destroy-on-close="true">
			<video :src="getVideoUrl()" controls style="width: 100%;height: 60vh;overflow: auto;">
			</video>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAnswerList,
		getAnswerFileList,
		setBestOrNot,
		assignMai,
		deleteOrBackAnswer,
		deleteAnswerFile,
	} from "@/api/mai/quizManagement/quizDetail";
	import {
		handleRes
	} from "@/utils/handleRes"
  import {
    getCloudUrl, getPreviewImgUrl
  } from "@/utils/urlutil"
	import {
		deepClone
	} from "@/utils/index"
  import UserInfo from "@/components/UserInfo/UserInfo";
  import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
	export default {
    components: {UserInfo},
    props: {
			problemId: Number,
		},
		data() {
			return {
        navigationKey:"answerList",

				totalCount: 0,
				pageSize: 10,
				currentPage: 1,
				tableData: [],
				answerFileTotalCount: 0,
				answerFilePageSize: 3,
				answerFileCurrentPage: 1,
				filesList: [],
				problemAnswerId: 0,
				fileDialogVisible: false,
				rewardDialogVisible: false,
				videoEntity: {},
				viewVideoDialog: false,

        //答案评论

			};
		},
		async created() {
      let navigationObj = getNavigationItemObj(this.navigationKey)
      this.currentPage = navigationObj.currentPage
      await this.refreshCurrentList();
		},
		methods: {
			getVideoUrl() {
				console.log("play url " + this.videoEntity.fileUrl)
				return getCloudUrl(this.videoEntity.fileUrl)
			},
			getImageUrl(entity) {
				return getPreviewImgUrl(entity)
			},
      /**
       * 预览视频
       * @param index
       * @param entity
       */
			viewVideo(index, entity) {

				this.videoEntity = entity;
				console.log("set url  " + entity.fileUrl)
				this.viewVideoDialog = true;
			},
			refreshCurrentList() {
				this.getAnswerList();
			},
			currentChange(currentPage) {
				this.currentPage = currentPage;
				this.refreshCurrentList();
			},
			answerFileCurrentPageChange(currentPage) {
				this.answerFileCurrentPage = currentPage
				this.getAnswerFileList()
			},
      /**
       * 答案列表请求接口
       */
			getAnswerList() {
        setNavigationItemWithObj(this.navigationKey,{
          currentPage:this.currentPage
        })
				getAnswerList({
					problemId: Number(this.problemId),
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
				}).then((res) => {
					handleRes(res, () => {
						this.tableData = res.data.rows;
						this.totalCount = res.data.total;
					})

				});
			},
      /**
       * 某个答案对应文件列表请求接口
       */
			getAnswerFileList() {
				getAnswerFileList({
					problemAnswerId: this.problemAnswerId,
					pageNumber: this.answerFileCurrentPage,
					pageSize: this.answerFilePageSize,
				}).then(res => {
					handleRes(res, () => {
						this.fileDialogVisible = true;
						this.filesList = res.data.rows
						this.answerFileTotalCount = res.data.total
					})

				})
			},
      /**
       * 答案评论
       * @param entity
       */
      handleViewReply(entity){
        this.$router.push({
          path:"quizAnswerReply",
          query:{
            problemAnswerId:entity.problemAnswerId
          }
        })
      },
      /**
       * 查看答案文件
       * @param row
       */
			handleCheckAnswerFile(row) {
				this.problemAnswerId = row.problemAnswerId;
				this.answerFileCurrentPage = 1
				this.getAnswerFileList()

			},
			/**
			 * 设置最佳答案
			 * @param {Object} row
			 */
			handleSwitchBest(row) {
				setBestOrNot({
					problemAnswerId: row.problemAnswerId
				}).then((res) => {
					handleRes(res, () => {
						this.refreshCurrentList()
					})
				});
			},
			handleSetReward(row) {
				this.$prompt("问答奖励", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						inputPlaceholder: "请输入要奖励的麦粒值",
						inputPattern: /^\d+$/,
						inputErrorMessage: "只能输入数字",
					})
					.then(({
						value
					}) => {
						const params = {
							problemId: row.problemId,
							userId: row.createUserId,
							value: Number(value),
						};
						assignMai(params).then((res) => {

							if (res.isError) {
								this.$message({
									type: "error",
									message: res.errorMessage,
								});
								this.refreshCurrentList();
							} else {
								this.$message({
									type: "success",
									message: "设置成功!",
								});
								this.refreshCurrentList();
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "取消输入",
						});
					});
			},
			handleRemoveAnswer(row) {
				let status = row.isDeleted ? "恢复" : "删除"
				this.$confirm(`是否${status}该答案`, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						deleteOrBackAnswer({
							problemAnswerId: row.problemAnswerId,
						}).then((res) => {
							handleRes(res, () => {
								this.getAnswerList()
							})
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "取消操作",
						});
					});
			},
			handleRemoveFile(row) {
				this.$confirm("是否删除该文件", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						deleteAnswerFile({
							answerFileId: row.answerFileId,
						}).then((res) => {
							handleRes(res, () => {
								this.getAnswerFileList()
							})
						});
					})
			},
		},
	};
</script>

<style>
</style>
